export type DensityMode = 'compact' | 'balanced' | 'focus';

export interface DensityConfig {
  mode: DensityMode;
  pagePadding: 'sm' | 'md' | 'lg';
  shellGap: 'space-y-4' | 'space-y-5' | 'space-y-6';
  cardPadding: 'p-3' | 'p-4' | 'p-5';
  headerScale: 'sm' | 'md';
}

export interface DensityInput {
  viewportWidth: number;
  isTouch: boolean;
}

export const resolveDensityMode = ({ viewportWidth, isTouch }: DensityInput): DensityMode => {
  if (isTouch && viewportWidth <= 900) return 'compact';
  if (viewportWidth >= 1440 && !isTouch) return 'focus';
  return 'balanced';
};

export const getDensityConfig = (mode: DensityMode): DensityConfig => {
  switch (mode) {
    case 'compact':
      return {
        mode: 'compact',
        pagePadding: 'sm',
        shellGap: 'space-y-4',
        cardPadding: 'p-3',
        headerScale: 'sm',
      };
    case 'focus':
      return {
        mode: 'focus',
        pagePadding: 'lg',
        shellGap: 'space-y-6',
        cardPadding: 'p-5',
        headerScale: 'md',
      };
    case 'balanced':
    default:
      return {
        mode: 'balanced',
        pagePadding: 'md',
        shellGap: 'space-y-5',
        cardPadding: 'p-4',
        headerScale: 'md',
      };
  }
};
